import { createFileRoute, Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useState } from "react";
import { stopWeeklyCheckins } from "@/lib/checkin-optout.functions";

export const Route = createFileRoute("/checkin-unsubscribe")({
  head: () => ({
    meta: [
      { title: "Stop weekly check-ins — Recovery Trauma™" },
      { name: "description", content: "Stop the weekly check-in emails from Recovery Trauma™." },
      { property: "og:title", content: "Stop weekly check-ins — Recovery Trauma™" },
      { property: "og:description", content: "Stop the weekly check-in emails from Recovery Trauma™." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  validateSearch: (s: Record<string, unknown>) => ({
    email: typeof s.email === "string" ? s.email : "",
    token: typeof s.token === "string" ? s.token : "",
  }),
  component: Page,
});

function Page() {
  const { email, token } = Route.useSearch();
  const stop = useServerFn(stopWeeklyCheckins);
  const [state, setState] = useState<"idle" | "busy" | "done" | "invalid">(email && token ? "idle" : "invalid");

  const confirm = async () => {
    setState("busy");
    try {
      const r = await stop({ data: { email, token } });
      setState(r.ok ? "done" : "invalid");
    } catch {
      setState("invalid");
    }
  };

  return (
    <main className="mx-auto max-w-md px-5 py-16 text-center">
      <h1 className="font-display text-2xl text-foreground">Weekly check-ins</h1>
      {state === "done" ? (
        <p className="mt-4 text-muted-foreground">Done — you won't receive any more weekly check-ins. Account and billing emails will still arrive.</p>
      ) : state === "invalid" ? (
        <p className="mt-4 text-muted-foreground">This link isn't valid or has been changed. Please use the link in your most recent check-in email, or write to info@recoverytrauma.com.</p>
      ) : (
        <>
          <p className="mt-4 text-muted-foreground">Stop the weekly check-in emails for <strong className="text-foreground">{email}</strong>? Your membership and account emails won't change.</p>
          <button onClick={confirm} disabled={state === "busy"}
            className="mt-6 rounded-full bg-primary px-6 py-3 font-medium text-primary-foreground disabled:opacity-60">
            {state === "busy" ? "One moment…" : "Stop weekly check-ins"}
          </button>
        </>
      )}
      <div className="mt-8"><Link to="/" className="text-sm text-primary underline">Back to Recovery Trauma™</Link></div>
    </main>
  );
}
